// tslint:disable:max-line-length

import React from 'react';

export const ObjectUser = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <circle cx="8" cy="4" r="4" />
      <path d="M7.9,9C3.9,9,0.5,12.1,0,16h15.9C15.4,12.1,12,9,7.9,9z" />
    </svg>
  );
};
